<template>
  <div class="page-actions">
    <v-btn
      v-for="item in actions"
      :key="item.label"
      rounded
      depressed
      :ripple="false"
      @click="callAction(item.action)"
      :loading="item.inProgress"
      :disabled="item.disabled"
      :outlined="false"
      v-if="item.hide != true"
      :data-qa="item['data-qa']"
      :class="[item.mainAction ? 'main-action' : '', item.pendoAction ? item.pendoAction : '']"
      :style="{ backgroundColor: item.mainAction ? mainAction.background : regularAction.background, color: item.mainAction ? mainAction.color : regularAction.color}"
      >
        {{$t(item.label)}}
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: "PageActions",
    components: {},
    props: ['actions'],
    data() {
      return {
        mainAction:{
          background:'var(--brand-color-secondary)',
          color: 'var(--brand-text-color)'
        },
        regularAction:{
          background: '#eaedf2',
          color: '#000000',
        }
      }
    },
    methods:{
      callAction(functionName){
        this.$emit("actionClicked",functionName)
      }
    }
  };
</script>
<style scoped lang="scss">
  @import "@/assets/scss/abstract/_variables.scss";
  @import "@/assets/scss/abstract/_mixins.scss";

  .page-actions{

    .v-btn{
      min-width: 120px;
      height: 32px;
      font-family: var(--primary-font-family);
      letter-spacing: normal;
      font-size: 12px;
      font-weight: 600;
      @include i-margin-mirror(0px, 10px);
      background-color: #eaedf2;
    }

    @include sm-and-down{
      display: flex;
      flex-direction: column-reverse;
      width: 92%;
      margin: 0px 4%;
      right: auto;
      position: relative;
      padding-bottom: 20px;
      bottom: auto;

      .v-btn{
        width: 100%;
        margin-top: 20px;
        height: 40px;

        &:last-of-type{
          margin-top: 33px;
        }
      }

    }
  }
</style>
